module.exports = __webpack_public_path__ + "static/img/p003.4f0ca70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/p003.png
// module id = VC3Y
// module chunks = 0